var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 217,
    height: 218,
    viewBox: "0 0 217 218",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M171.601 18.9088H45.3987C38.2329 18.9302 31.3667 21.7863 26.2997 26.8533C21.2327 31.9203 18.3766 38.7865 18.3552 45.9523V125.821L53.3314 90.8444C58.485 85.9393 65.3274 83.2036 72.4421 83.2036C79.5569 83.2036 86.3993 85.9393 91.5528 90.8444L117.433 116.869L125.438 108.864C130.519 103.812 137.393 100.976 144.558 100.976C151.723 100.976 158.597 103.812 163.678 108.864L198.645 143.85V45.9523C198.624 38.7865 195.767 31.9203 190.7 26.8533C185.633 21.7863 178.767 18.9302 171.601 18.9088Z",
    fill: "#B7C8F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5528 90.8484C86.3993 85.9432 79.5569 83.2075 72.4421 83.2075C65.3274 83.2075 58.485 85.9432 53.3314 90.8484L18.3552 125.825V172.159C18.3766 179.325 21.2327 186.191 26.2997 191.258C31.3667 196.325 38.2329 199.181 45.3987 199.202H171.601C175.238 199.2 178.837 198.465 182.182 197.04C185.528 195.615 188.552 193.53 191.073 190.909L91.5528 90.8484Z",
    fill: "#7291DA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M198.647 143.828L163.68 108.861C158.599 103.808 151.725 100.972 144.56 100.972C137.395 100.972 130.521 103.808 125.44 108.861L117.435 116.866L191.039 190.865C195.924 185.862 198.656 179.147 198.647 172.151V143.828Z",
    fill: "#B9CDFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.25c47f8449641bac7abf96ecd1990ede.svg";
export { ForwardRef as ReactComponent };